import { createPinia } from 'pinia'
import { type UserModule } from '~/types'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'

export const install: UserModule = ({
  isClient,
  initialState,
  app,
  onSSRAppRendered
}) => {
  console.log('isClient:', isClient)
  const pinia = createPinia()
  pinia.use(piniaPluginPersistedstate)
  app.use(pinia)
  if (isClient) pinia.state.value = initialState.pinia || {}
  else {
    onSSRAppRendered(() => {
      initialState.pinia = pinia.state.value
    })
  }
}
